export var getClassName = function getClassName(defaultClassName, className) {
  return className ? className.split(' ').concat(defaultClassName).join(' ') : defaultClassName.join(' ');
};